export const PAGE_TITLE = 'Проверка электронной почты';
export const DESCRIPTION =
  'Проверка электронной почты для зарегистрированного пользователя';
export const KEYWORDS = 'электронная почта, проверка, цопп';

export const SUCCESS_TITLE = 'Спасибо! Электронная почта подтверждена.';
export const SUCCESS_MESSAGE =
  'Теперь вы можете редактировать свой профиль, оставлять заявки, отзывы и комментарии.';

export const ERROR_TITLE = 'К сожалению при подтверждении возникли вопросы.';
export const ERROR_MESSAGE =
  'Возможно вы ошиблись со ссылкой для подтверждения или ваша почта уже была подтверждена ранее. Пожалуйста, обратитесь к специалистам клиентской поддержки, контакты указаны в нижней части сайта.';



// WEBPACK FOOTER //
// ./src/pages/verify/email/const.js